import { render, staticRenderFns } from "./MarkerCard.vue?vue&type=template&id=70fb5d30&scoped=true&"
import script from "./MarkerCard.vue?vue&type=script&lang=js&"
export * from "./MarkerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fb5d30",
  null
  
)

export default component.exports